import React, { useState, useEffect } from "react";
import { fetchContacts, createContact } from "../api/contactService";

function ContactSearchModal({ isOpen, onClose, onSelect }) {
  const [query, setQuery] = useState("");
  const [contacts, setContacts] = useState([]);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [newContact, setNewContact] = useState({ first_name: "", last_name: "", phone: "" });

  useEffect(() => {
    if (query.length < 2) {
      setContacts([]);
      return;
    }

    const fetchMatchingContacts = async () => {
      try {
        const response = await fetchContacts({ search: query });
        setContacts(response);
      } catch (error) {
        console.error("Error fetching contacts:", error);
      }
    };

    const debounceTimeout = setTimeout(fetchMatchingContacts, 300);
    return () => clearTimeout(debounceTimeout);
  }, [query]);

  const handleSelect = (contact) => {
    onSelect(contact.contact_id, `${contact.first_name} ${contact.last_name}`);
    onClose();
  };

  const handleCreateContact = async (e) => {
    e.preventDefault();
    try {
      const createdContact = await createContact(newContact);
      onSelect(createdContact.contact_id, `${createdContact.first_name} ${createdContact.last_name}`);
      setShowCreateForm(false);
      onClose();
    } catch (error) {
      console.error("Error creating contact:", error);
    }
  };

  return isOpen ? (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-lg rounded-lg shadow-lg p-6">
        <h3 className="text-lg font-semibold mb-4">Search Contact</h3>

        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search by name or phone"
          className="border p-2 rounded w-full"
        />

        {contacts.length > 0 && (
          <ul className="mt-2 border rounded max-h-40 overflow-y-auto">
            {contacts.map((contact) => (
              <li
                key={contact.contact_id}
                onClick={() => handleSelect(contact)}
                className="p-2 cursor-pointer hover:bg-gray-100"
              >
                {contact.first_name} {contact.last_name} ({contact.phone})
              </li>
            ))}
          </ul>
        )}

        <button className="mt-4 text-blue-600 text-sm" onClick={() => setShowCreateForm(true)}>
          + Create New Contact
        </button>

        {showCreateForm && (
          <form onSubmit={handleCreateContact} className="mt-4 space-y-3">
            <input type="text" placeholder="First Name" required />
            <input type="text" placeholder="Last Name" />
            <input type="text" placeholder="Phone" required />
            <button type="submit" className="px-4 py-2 bg-green-600 text-white rounded-md">
              Save Contact
            </button>
          </form>
        )}
      </div>
    </div>
  ) : null;
}

export default ContactSearchModal;